import _ from 'lodash'
import $ from 'jquery'
// import Promise from 'bluebird'
import anime from 'animejs'
import {registPage as Page, Ajax, scrollElem, actionGuard} from 'eyes-lib/src/module/web'
import {nvl, toInt, sleep} from 'eyes-lib/src/module/basic'
import {TXT} from 'eyes-lib/src/module/string'
import {currency, urlInfo, QueryString, range} from 'eyes-lib/src/module/util'

import * as ShareFunc from './modules/sharefunc'
import * as router from './modules/router'
import * as menu from './modules/menu'
import * as Store from './modules/store'
import {PNotify, Behavior} from './modules/behavior'
import Timeout from 'await-timeout'

/**
 * このコードを読むことになった人へ
 * 関数化されているので実行順序としては、
 * 最終行の `router.dispatch()` から処理が始まります。
 * 関数の実行順序は`router.regist(...)`で定義されています。
 */

/** 利用する機能を選出 */
const {fetchItem, ApiError, disp, fav, fx} = ShareFunc
const {App, SearchDomState, SearchState, SearchMenuOption} = Store
const {EVENTS, convertToState, convertToParam, createSearchURL, KEYS} = menu

const PAGE_TITLE = `ツアー一覧`

/***************************************************************
 * 料金from ~ to 表示用関数
 * @param {number} min - 最小料金
 * @param {number} max - 最大料金
 **************************************************************/
function priceFromTo(min = 0, max = 0) {
	return TXT`<ul>
		|   <li class="From"><span class="Price">${currency(min)}</span> <span class="Unit">円</span></li>
		|   <li class="To"><span class="Price">${currency(max)}</span> <span class="Unit">円</span></li>
		|</ul>`
}

/** アラートオプション */
const AlertOptions = Object.assign({width: '400px'}, Behavior.PNotify.v4.AlertOptions)

/** PNotifyを使ったPromise化された簡単なアラート */
const PNotifyAlert = function (message, title = '通知') {
	// console.log({message, title})
	return new Promise((resolve) => {
		//@ts-ignore
		const notice = new PNotify.alert(
			Object.assign(AlertOptions, {
				title: nvl(title),
				text: nvl(message),
			}),
		)
		notice.on(Behavior.PNotify.EVENTS.CONFIRM, resolve)
		notice.on(Behavior.PNotify.EVENTS.CLOSE, resolve)
	})
}

/***************************************************************
 * ページ処理
 **************************************************************/
const loadSearchPage = Page(async function loadSearchPage(ctx) {
	/** ルーターのコンテキスト値 */
	//console.log('--------------- searchPage ---------------')

	/** @type {string} */
	const BRANCHGCD = _.get(ctx, 'params.BRANCHGCD')

	/** 事業所コードを束縛させたcreateSearchURL */
	const createSearchURLBinded = _.bind(createSearchURL, null, _, BRANCHGCD)

	/** 利用するDOMを定義 */
	const $dom = {
		pagerArea: $('.Pager'),
		sortArea: $('.ResultSort').eq(0),
		planArea: $('.ResultPlanArea').eq(0),
		favArea: $('.ButtonFavorite'),
	}

	/** 初回 画面リセット */
	$dom.pagerArea.empty()
	$dom.planArea.empty()

	/** お気に入り状態を表示(お気に入りは重要ではないので遅延実行させたい) */
	Promise.resolve(0).then(drawFavArea)

	/**
	 * URL変更イベント登録
	 */
	menu.event.on(EVENTS.URL_CHANGE, stateChangeAction)

	/** ブラウザの進む、戻るイベント */
	$(window).on('popstate', () => menu.event.emit(EVENTS.URL_CHANGE))

	/** スクロール判定フラグ */
	let isScrollToTop = false

	/** TOPスクロールイベント登録 */
	$(window).on('scrollToTop', () => {
		if (isScrollToTop) {
			const $target = $('.ResultHeadArea')
			anime({
				targets: scrollElem,
				scrollTop: $target.offset().top,
				duration: 380,
				easing: 'easeOutQuart',
			})
		}
	})

	const scrollJudgeElem = $('.ResultHeadArea').get(0)

	/**
	 * スクロール判定
	 * @param {IntersectionObserverEntry[]} entries
	 * @param {IntersectionObserver} observer
	 */
	const handler = (entries, observer) => {
		_.each(entries, (entry) => {
			isScrollToTop = entry.target === scrollJudgeElem && false === entry.isIntersecting
		})
	}

	/** スクロールさせるか基準となるDOMを監視 */
	const observer = new IntersectionObserver(handler)
	observer.observe(scrollJudgeElem)

	/** 検索イベント登録 */
	menu.event.on(EVENTS.SEARCH, searchAction)

	/** 初回画面表示(検索)イベント登録 */
	menu.event.on(EVENTS.INIT, firstEvent)

	/** お気に入り保存ボタンイベント */
	const FavAlert = _.bind(PNotifyAlert, null, _, 'お気に入り')
	$('.Main')
		.on(
			'click',
			'.FavoriteBtn.save',
			actionGuard(
				(evt) => {
					const $self = $(evt.currentTarget)
					/** @type {import('./modules/store').DetailData} */
					const shohin = $self.data('ShohinInfo')
					fav.addFavoriteData(shohin, async function (err, data) {
						if ('max' == err) {
							await FavAlert(`保存できる件数は${data.max}件までです`)
						} else if ('already' == err) {
							await FavAlert(`すでに保存されています`)
						} else {
							await Promise.all([drawFavArea(), FavAlert(`保存しました`)])
							$self.removeClass('save').addClass('delete').text('お気に入りから削除')
						}
					})
				},
				{stop: true},
			),
		)
		.on(
			'click',
			'.FavoriteBtn.delete',
			actionGuard((evt) => {
				const $self = $(evt.currentTarget)
				/** @type {import('./modules/store').DetailData} */
				const shohin = $self.data('ShohinInfo')
				fav.delFavoriteData(shohin.tourcode, shohin.branchcode, async function (err, data) {
					if (err) {
						FavAlert(`削除できませんでした`)
					} else {
						await Promise.all([drawFavArea(), FavAlert(`削除しました`)])
						$self.removeClass('delete').addClass('save').text('お気に入りに保存')
					}
				})
			}),
		)

	/***************************************************************
	 * 初回検索アクション
	 * @description メニューの初期化が完了し、マスタ読み込みと検索処理を待つ
	 **************************************************************/
	async function firstEvent() {
		/** READYイベントを待つPromise */
		const onReady = new Promise((resolve) => {
			menu.event.once(menu.EVENTS.READY, () => {
				console.info(`--------------- ${menu.EVENTS.READY} ---------------`)
				resolve(menu.EVENTS.READY)
			})
		})

		const timer = new Timeout()
		try {
			await Promise.race([
				Promise.all([onReady, stateChangeAction()]),
				timer.set(60000, 'Timeout[stateChangeAction]'),
			])

			timer.clear()
			menu.lazyActionRegist()

			console.info('--------------- Search Page Finish ---------------')
		} catch (err) {
			console.error(err)
			await fx.loadingEnd()
		} finally {
			timer.clear()
		}
	}

	/***************************************************************
	 * URL変更イベント
	 **************************************************************/
	async function stateChangeAction() {
		/** URLクエリパラメータをオブジェクト化 */
		const info = urlInfo(App.location.href)
		// console.log( urlInfo )
		/** クエリオブジェクトから検索状態に適用するオブジェクトに変換 */
		const urlState = convertToState(info.param)
		const myState = _.merge(SearchState.new(), urlState)

		/** パラメータチェック */
		menu.validSearchParams(myState)

		console.info('--------------- URL変更アクション ---------------', myState)
		App.permanentSession.setItem(KEYS.SEARCH_STATE, myState)
		App.permanentSession.setItem(KEYS.SEARCH_URL, info.href)

		/** 検索状態オブジェクトにマージ(検索メニュー画面が自動でレンダリングされる) */
		Store.domStateMerge(SearchDomState, myState)

		/** TOPスクロールイベント発行 */
		$(window).trigger('scrollToTop')

		/** 検索実行 */
		await fx.loadingStart()
		await doSearch()
	}

	/** URL PUSH 画面遷移しないでURLを変更させたい要素を設定 */
	$('.SearchPage').on(
		'click',
		'.url-push',
		actionGuard(
			/** @param {Event} evt */
			(evt) => {
				const pathURL = $(evt.currentTarget).attr('href')
				// console.info({pathURL})
				history.pushState(null, PAGE_TITLE, pathURL)
				menu.event.emit(EVENTS.URL_CHANGE)
			},
		),
	)

	/** お気に入りページへ遷移 */
	$dom.favArea.on(
		'click',
		actionGuard(() => {
			const favoriteCart = fav.packFavoriteData()
			$('#favoritedata').val(JSON.stringify(favoriteCart))
			$('#ff').submit()
		}),
	)

	/***************************************************************
	 * お気に入り状態表示エリアを描画する
	 **************************************************************/
	async function drawFavArea() {
		const favInfo = fav.getFavoriteCountInfo()
		$('.Total', $dom.favArea).text(favInfo.size)
		$('.Max', $dom.favArea).text(favInfo.max)
	}

	/***************************************************************
	 * 検索結果一覧を描画する
	 * @param {import('./modules/store').TempSearchShohin[]} data
	 **************************************************************/
	async function drawResult(data) {
		/** 画面リセット */
		$dom.planArea.empty()

		const headercd = _.get(App.data, 'headercd', '')
		const agentcd = _.get(App.data, 'agentcd', '')
		//const branch_cd = _.get(App.data, 'branch_cd', '')

		/** データ操作 */
		const pList = _.chain(data)
			.map((val) => {
				const item = _.merge(Store.TempSearchShohin.new(), val)

				/** テンプレート取得 */
				const $base = App.template.get('PlanBox')

				/** フェードイン要素として扱うためfadeクラス付与 */
				$base.addClass('fade')

				/** テンプレートへ値を反映 */
				$('.Title h3 a', $base).html(item.name)
				$('.Title p', $base).html(item.subtitle)

				/** 画像 */
				const imgPath = item?.kensakuimage ?? ''
				$('.Photo img', $base)
					.on('error', function (evt) {
						const $elem = $(evt.currentTarget)
						//404取得できない場合の処理
						$elem.parent().prepend($('<img src="/eyeswork/TTT/img/noimage.jpg" alt="NO IMAGE">'))
						$elem.remove()
					})
					.attr('src', imgPath)

				/** iconタグ */
				{
					const $iconArea = $('.Picky ul', $base)
					// console.warn('item.icon', item.icon)

					/** iconタグエリア初期化 */
					$iconArea.empty()

					/** iconタグ append */
					_(item.icon)
						.chain()
						.split('//')
						.compact()
						.map((val) => `<li>${val}</li>`)
						.each((val) => $iconArea.append(val))
						.commit()
				}

				/** カレンダーページに送信するパラメータ */
				const params = {
					c1: item.code1,
					c2: item.code2,
					c3: item.code3,
					br: item.branchcd,
					hcd: headercd,
					agent: agentcd,
				}
				if (_.get(SearchDomState, 'dep_yymm')) params.ym = SearchDomState.dep_yymm

				if (_.get(SearchDomState, 'dep_dd')) params.dd = SearchDomState.dep_dd

				/** 詳細ページリンク */
				const queryParam = QueryString.stringify(params)

				const contextPath = (()=>{
					/** 個人と団体で遷移先を変更する */
					if( `${item.tourflag}` == "1" )
					{
						// 団体の場合
						if ( /_dev/.test(App.SYSTEM_PATH) )
							return `/dom_tour_sys_dev/domtour`
						else if ( /_stg/.test(App.SYSTEM_PATH) )
							return `/dom_tour_sys_stg/domtour`
						else
							return `/dom_tour_sys/domtour`
					}
					else
					{
						// 個人の場合
						if ( /_dev/.test(App.SYSTEM_PATH) )
							return `/dom_tour_sys_tin_dev/tintour`
						else if ( /_stg/.test(App.SYSTEM_PATH) )
							return `/dom_tour_tin_stg/tintour`
						else
							return `/dom_tour_tin/tintour`
					}

				})()

				const detailLink = `${contextPath}/detail?${queryParam}`
				$('.DetailBtn', $base).attr('href', detailLink)
				$('.Title h3 a', $base).attr('href', detailLink)

				/** 泊数情報 */
				const webHakuDay = disp.hakuDay(item.webhaku, item.webday)
				$('.TravelPeriod', $base).text(webHakuDay)

				/** 料金情報 */
				$('.PlanPrice ul', $base).empty().html(priceFromTo(item.minprice, item.maxprice))

				/** 商品コード(コース番号) */
				$('.PlanCode span', $base).eq(1).text(disp.tourCode(item.code1, item.code2, item.code3))

				/** 設定期間 */
				$('.SetPeriod .From span', $base).text(disp.dateStrFormat(item.kikanfrom))
				$('.SetPeriod .To span', $base).text(disp.dateStrFormat(item.kikanto))

				/** その他情報 */
				$('.PlanEtc td', $base).eq(0).text(item.fromtoshi)
				$('.PlanEtc td', $base).eq(1).text(item.totoshi)
				$('.PlanEtc td', $base).eq(2).text(item.traffic)
				const $hotelInfo = $('.PlanEtc td', $base).eq(3).find('ul')

				/** いったんクリア */
				$hotelInfo.empty()

				_(item.hotel)
					.chain()
					.split(`//`)
					.map((val) => $('<li></li>').text(val))
					.each(($elem, idx) => {
						$hotelInfo.append($elem)
					})
					.tap(($elems) => {
						/** 1件以上の場合 toggleボタン表示 */
						if ($elems.length > 1) {
							/** 最初の1件目はAccクラスつける */
							_.head($elems)
								.addClass('Acc')
								.on('click', (evt) => $(evt.currentTarget).toggleClass('open').nextAll('li').toggle())
							/** 2件以外は隠す */
							_.tail($elems).forEach(($elem) => $elem.hide())
						}
					})
					.commit()

				/** お気に入り保存をバインド */
				{
					const shohin = Store.DetailData.new()
					shohin.tourcode = disp.tourCode(item.code1, item.code2, item.code3)
					shohin.branchcode = item.branchcd
					shohin.subtitle = item.subtitle
					shohin.minprice = currency(item.minprice)
					shohin.maxprice = currency(item.maxprice)
					shohin.termday = webHakuDay
					shohin.title = item.name
					shohin.headercode = headercd

					if (fav.hasFavoriteData(shohin.tourcode, shohin.branchcode)) {
						$('.Favorite button', $base)
							.data('tc', shohin.tourcode)
							.data('br', shohin.branchcode)
							.data('ShohinInfo', shohin)
							.removeClass('save')
							.addClass('delete')
							.text('お気に入りから削除')
					} else {
						$('.Favorite button', $base)
							.data('tc', shohin.tourcode)
							.data('br', shohin.branchcode)
							.data('ShohinInfo', shohin)
							.removeClass('delete')
							.addClass('save')
							.text('お気に入りに保存')
					}
				}
				return $base
			})
			.map(($base, idx) => {
				/** DOMへテンプレートを挿入 */
				$dom.planArea.append($base)

				/** n秒後にfadeInクラス付与 */
				return Promise.resolve(0)
					.then(() => sleep(idx * 160))
					.then(() => $base.addClass('fadeIn'))
			})
			.value()
		await Promise.all(pList)
	}

	/***************************************************************
	 * ページングUIを描画する
	 * @param {PageInfo} pageInfo
	 **************************************************************/
	async function drawPaging(pageInfo) {
		/** 画面リセット */
		$dom.pagerArea.empty()

		// console.warn( pageInfo )

		/** URLパラメータから現在の状態を取得 */
		const myState = (() => {
			const urlinfo = urlInfo()
			/** クエリオブジェクトから検索状態に適用するオブジェクトに変換 */
			const urlState = convertToState(urlinfo.param)
			return _.merge(SearchState.new(), urlState)
		})()

		/** 件数表示エリアの描画 */
		{
			/** テンプレート取得 */
			const $num = App.template.get('ResultNum')
			const fromNum = 0 === pageInfo.total ? 0 : pageInfo.from
			const toNum = pageInfo.total < pageInfo.to ? pageInfo.total : pageInfo.to

			/** テンプレートへ値を反映 */
			$('.From', $num).html(`${fromNum}`)
			$('.To', $num).html(`${toNum}`)
			$('.TotalCount', $num).html(`${pageInfo.total}`)

			/** DOMへテンプレートを挿入 */
			$dom.pagerArea.append($num)
		}

		/** 並び替えリンク設定 */
		{
			const $sortLinks = $('li', $dom.sortArea)
			/** 新着順リンク */
			const sortLink0 = (() => {
				const stat = _.cloneDeep(myState)
				stat.sort = 0
				stat.page = 1
				return createSearchURLBinded(stat)
			})()
			/** 安い順リンク */
			const sortLink1 = (() => {
				const stat = _.cloneDeep(myState)
				stat.page = 1
				stat.sort = 1
				stat.page = 1
				return createSearchURLBinded(stat)
			})()
			/** 高い順リンク */
			const sortLink2 = (() => {
				const stat = _.cloneDeep(myState)
				stat.sort = 2
				stat.page = 1
				return createSearchURLBinded(stat)
			})()

			/** リンク設定 */
			$sortLinks.eq(0).find('a').attr('href', sortLink0)
			$sortLinks.eq(1).find('a').attr('href', sortLink1)
			$sortLinks.eq(2).find('a').attr('href', sortLink2)

			/** スタイル変更 */
			$sortLinks.removeClass('active')
			if (1 == SearchDomState.sort) $sortLinks.eq(1).addClass('active')
			else if (2 == SearchDomState.sort) $sortLinks.eq(2).addClass('active')
			else $sortLinks.eq(0).addClass('active')
		}

		/** ページングエリアの描画 */
		{
			const $pager = App.template.get('ResultPager')
			// console.log(pageInfo)

			/** ページリスト取得 */
			const pageList = range(1, pageInfo.pagemax).center(pageInfo.page, 5)
			//console.log(pageList)
			const pageLastIndex = pageList.length - 1
			const pageElem = _.chain(pageList)
				.reduce((acc, page, key) => {
					//console.log(page, key)

					if (key === 0) {
						/** 先頭URL */
						const headLink = (() => {
							const stat = _.cloneDeep(myState)
							stat.page = 1
							return createSearchURLBinded(stat)
						})()

						/** 一つ前URL */
						const prevLink = (() => {
							const stat = _.cloneDeep(myState)
							stat.page = Math.max(stat.page - 1, 1) // 最低1
							return createSearchURLBinded(stat)
						})()

						if (pageInfo.page == 1) {
							acc.push(`<li><span>最初へ</span></li>`)
							acc.push(`<li><span data-text="前へ"></span></li>`)
						} else {
							acc.push(`<li><a href="${headLink}" class="url-push">最初へ</a></li>`)
							acc.push(`<li><a href="${prevLink}" data-text="前へ" class="url-push"></a></li>`)
						}

						if (_.head(pageList) > 1) acc.push(`<li><span class="Dot">…</span></li>`)
					}

					{
						/** 対象ページURL */
						const pageLink = (() => {
							const stat = _.cloneDeep(myState)
							stat.page = toInt(page)
							return createSearchURLBinded(stat)
						})()

						if (pageInfo.page == page)
							acc.push(
								`<li class="Active"><a href="${pageLink}" data-page="${page}" data-text="ページ" class="url-push">${page}</a></li>`,
							)
						else if (page > -1)
							acc.push(
								`<li><a href="${pageLink}" data-page="${page}" data-text="ページ" class="url-push">${page}</a></li>`,
							)
					}

					if (pageLastIndex === key) {
						/** 一つ後ろURL */
						const nextLink = (() => {
							const stat = _.cloneDeep(myState)
							stat.page = Math.min(stat.page + 1, pageInfo.pagemax) // 最大 pagemax
							return createSearchURLBinded(stat)
						})()

						/** 最終ページURL */
						const lastLink = (() => {
							const stat = _.cloneDeep(myState)
							stat.page = pageInfo.pagemax
							return createSearchURLBinded(stat)
						})()

						if (_.last(pageList) < pageInfo.pagemax) acc.push(`<li><span class="Dot">…</span></li>`)
						if (pageInfo.page == pageInfo.pagemax) {
							acc.push(`<li><span data-text="次へ"></span></li>`)
							acc.push(`<li><span>最後へ</span></li>`)
						} else {
							acc.push(`<li><a href="${nextLink}" data-text="次へ" class="url-push"></a></li>`)
							acc.push(`<li><a href="${lastLink}" class="url-push">最後へ</a></li>`)
						}
					}

					return acc
				}, [])
				.join('')
				.value()

			$pager.html(`<ul>${pageElem}</ul>`)

			/** DOMへテンプレートを挿入 */
			$dom.pagerArea.append($pager)
		}
	}

	/***************************************************************
	 * 検索実装
	 **************************************************************/
	async function doSearch() {
		try {
			/** 現状の検索結果一覧をfadeOut */
			$('.PlanBox.fade.fadeIn', $dom.planArea).removeClass('fadeIn')

			/** 差分抽出で利用するデフォルトパラメータオブジェクト */
			const paramData = convertToParam(_.merge({}, SearchState.new(), SearchDomState))
			const paramQuery = QueryString.stringify(paramData)

			const resData = await Ajax.load({
				url: `${App.CONTEXT_PATH}/api/v1/search/${BRANCHGCD}?${paramQuery}`,
				method: `GET`,
			}).then(fetchItem)

			//console.log(resData)
			await fx.loadingEnd()

			/** 必要な情報を各描画関数(Promise)に渡す */
			const paging = drawPaging(_.pick(resData, ['from', 'page', 'pagemax', 'size', 'to', 'total']))

			/** 必要な情報を各描画関数(Promise)に渡す */
			const result = drawResult(_.get(resData, 'data', []))

			/** まだ描画関数の結果をここで待つ。Promise.raceの並行処理なのでどれか一つでも結果が返れば次へ進む */
			await Promise.all([paging, result])
		} catch (err) {
			console.log('err', err)
			await fx.loadingEnd()

			if (err instanceof ApiError) {
				console.log('ApiError')
			}
		}
	}

	/***************************************************************
	 * 検索アクション
	 **************************************************************/
	async function searchAction(pathURL) {
		/** URLパラメータにシリアライズ化してURLを更新 */
		history.pushState(null, PAGE_TITLE, pathURL)

		/** イベント発行 */
		menu.event.emit(EVENTS.URL_CHANGE)
	}
})

/***************************************************************
 * 初回表示時に実行(検索)
 **************************************************************/
const firstSearch = Page(async function firstSearch(ctx) {
	console.log('--------------- firstSearch ---------------')
	/** 初回検索イベント発行 */
	menu.event.emit(EVENTS.INIT)
})

/***************************************************************
 * 検索メニュー読み込み
 **************************************************************/
const loadSearchMenu = Page(async function loadSearchMenu(ctx) {
	console.log('--------------- searchMenu ---------------')
	/** Firefoxでブラウザバック時、jsが動かない対策 */
	window.onunload = function () {}

	/** @type {string} */
	const BRANCHGCD = _.get(ctx, 'params.BRANCHGCD')

	/** URLクエリパラメータをオブジェクト化 */
	const urlinfo = urlInfo()

	/** クエリオブジェクトから検索状態に適用するオブジェクトに変換 */
	const urlState = convertToState(urlinfo.param)

	/** 各検索マスタグループを抽出 */
	const groupState = _.pick(urlState, ['dep_grp', 'hmn_grp', 'cho_grp', 'trf_grp', 'tem_grp', 'ysn_grp', 'pax_grp'])

	/** 検索メニュー制御オプション設定 */
	const searchMenuOption = SearchMenuOption.new()

	/** 検索ボタンで画面遷移させない */
	searchMenuOption.goto = false

	/** 各検索マスタグループをマージ */
	_.merge(searchMenuOption, groupState)

	/** 検索メニューに息吹を */
	return await menu.searchMenu(BRANCHGCD, searchMenuOption)
})

/***************************************************************
 * ルーティング設定
 * 下記設定のルーティングパスに対して
 * 順番に関数が実行されていきます
 **************************************************************/
router.regist(`${App.SYSTEM_PATH}/:LANG?/search/:BRANCHGCD`, loadSearchMenu, loadSearchPage, firstSearch)

/** ページ処理開始 */
router.dispatch()
